import { render, staticRenderFns } from "./MoreSwitchAccount.vue?vue&type=template&id=15561bb0&scoped=true&"
import script from "./MoreSwitchAccount.vue?vue&type=script&lang=ts&"
export * from "./MoreSwitchAccount.vue?vue&type=script&lang=ts&"
import style0 from "./MoreSwitchAccount.vue?vue&type=style&index=0&id=15561bb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15561bb0",
  null
  
)

export default component.exports